import {
  USER_LOADED,
  REGISTER_SUCCESS,
  REGISTER_FAIL,
  USER_GROUP_SELECTED,
  GROUPS_LOADED,
  LOGOUT,
  FETCHING_MULTIPLE_USERS,
  LOADED_MULTIPLE_USERS,
  FETCH_MULTIPLE_USERS_FAILED,
  RESET_USER_GROUP_SELECTED,
  CREATE_ACCOUNT_INFORMATION,
} from "../actions/ActionTypes";

const initialState = {
  loading: true,
  error: {},
  user: null,
  userGroup: null,
  groups: [],
  accountInfo: {},
};

export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case USER_LOADED:
      return {
        ...state,
        user: payload,
        loading: false,
      };

    case REGISTER_SUCCESS:
      return {
        ...state,
        user: payload,
        loading: false,
      };

    case REGISTER_FAIL:
      return {
        ...state,
        error: payload,
        loading: false,
      };

    case USER_GROUP_SELECTED:
      return {
        ...state,
        userGroup: payload,
        loading: false,
      };

    case RESET_USER_GROUP_SELECTED:
      return {
        ...state,
        userGroup: null,
        users: [],
      };

    case GROUPS_LOADED:
      return {
        ...state,
        groups: payload,
        userGroup: null,
        loading: false,
      };

    case LOGOUT:
      return {
        ...state,
        user: null,
        userGroup: null,
      };

    case FETCHING_MULTIPLE_USERS:
      return {
        ...state,
        loading: true,
      };

    case LOADED_MULTIPLE_USERS:
      return {
        ...state,
        loading: false,
        users: payload,
      };

    case FETCH_MULTIPLE_USERS_FAILED:
      return {
        ...state,
        loading: false,
        users: [],
        error: payload,
      };

    case CREATE_ACCOUNT_INFORMATION:
      return {
        ...state,
        accountInfo: payload,
      };

    default:
      return state;
  }
}
